import CopyFixList from './CopyFixList';
import { extractFaqHtml } from '../../../../lib/optimizedContent';

export default function FaqFix({ domain, onFixApplied }) {
  return (
    <CopyFixList
      domain={domain}
      pillarCode="faqStructure"
      threshold={10}
      extract={extractFaqHtml}
      copyLabel={(e) =>
        `FAQ section with ${e.count} Q&A ${e.count === 1 ? 'pair' : 'pairs'}`
      }
      clipboardText={(e) => e.html}
      emptyHint="Re-audit if you’ve recently published an FAQ section."
      onFixApplied={onFixApplied}
      instructions={[
        <>
          Paste the copied <code className="px-1 bg-white border border-emerald-200 rounded text-[10px]">&lt;section class=&quot;faq&quot;&gt;</code> block into the visible body of your page (usually before the footer).
        </>,
        'Deploy the change to your live site.',
        <>
          Re-run the audit — <strong>FAQ sections present</strong> should now Pass.
        </>,
      ]}
    />
  );
}
